<template>
  <section class="section container pt-0">
    <vue-particles
      id="tsparticles"
      @particles-loaded="particlesLoaded"
      :options="{
        fpsLimit: 120,
        interactivity: {
          events: {
            onClick: {
              enable: true,
              mode: 'push',
            },
            onHover: {
              enable: true,
              mode: 'grab',
            },
          },
          modes: {
            bubble: {
              distance: 400,
              duration: 2,
              opacity: 0.8,
              size: 40,
            },
            push: {
              quantity: 1,
            },
            repulse: {
              distance: 50,
              duration: 0.4,
            },
            grab: {
              distance: 200,
              duration: 0.4,
            },
          },
        },
        particles: {
          color: {
            value: '#ffffff',
          },
          links: {
            color: '#ffffff',
            distance: 150,
            enable: true,
            opacity: 0.5,
            width: 1,
          },
          move: {
            direction: 'none',
            enable: true,
            outModes: 'out',
            random: false,
            speed: 2,
            straight: false,
          },
          number: {
            density: {
              enable: true,
            },
            value: 10,
          },
          opacity: {
            value: 0.5,
          },
          shape: {
            type: 'circle',
          },
          size: {
            value: { min: 1, max: 3 },
          },
        },
        detectRetina: true,
      }"
    />
    <!-- <div class="fixed-grid has-auto-count"> -->
    <div class="columns">
      <div class="column"></div>
      <div class="has-text-centered column is-4">
        <input
          class="input is-rounded"
          type="text"
          :placeholder="$t('search module')"
          v-model="search"
          ref="search_input"
        />
      </div>
      <div class="column"></div>
    </div>
    <div class="grid is-col-min-7">
      <div
        class="cell"
        v-for="(current_module, midx) in shown_modules"
        :key="midx"
        @click="go_to_module(current_module)"
      >
        <div class="card">
          <div class="card-image">
            <figure
              class="image is-64x64 m-auto py-4"
              v-bind:style="[
                current_module.matches_filter
                  ? { opacity: 1 }
                  : { opacity: 0.3 },
              ]"
            >
              <img
                :src="
                  current_module.settings.home_icon
                    ? current_module.settings.home_icon
                    : 'https://via.placeholder.com/48'
                "
              />
            </figure>
          </div>
          <div class="card-content px-0">
            <div class="media">
              <div class="media-content">
                <p
                  class="title is-5 has-text-centered"
                  v-bind:class="{
                    'has-text-grey-dark': !current_module.matches_filter,
                  }"
                >
                  {{ $t(current_module.settings.home_title) }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- </div> -->
  </section>
</template>

<script>
import { get, error_message, user_data } from "@/utils";
// import Artyom from "artyom.js";

export default {
  name: "HomeView",
  // components: { Particles },
  data() {
    return {
      modules: [],
      shown_modules: [],
      search: "",
    };
  },
  computed: {
    icon() {
      return user_data().logo || "/img/modul/Modul-12.png";
      // console.log(user_data());
      // return "/img/modul/Modul-12.png";
    },
  },
  methods: {
    get_home_modules() {
      let v = this;
      v.$root.loader(true);
      get("/system/authentication/modules", {})
        .then((r) => {
          // console.log("modules", r);
          let indexed = r
            .filter((m) => m.last_index_update_date)
            .sort((a, b) => {
              if (a.index < b.index) return -1;
              else if (a.index > b.index) return 1;
              else if (a.index == b.index) {
                if (a.last_index_update_date < b.last_index_update_date)
                  return -1;
                else if (a.last_index_update_date > b.last_index_update_date)
                  return 1;
                else if (a.last_index_update_date == b.last_index_update_date)
                  return 0;
              }
            });
          let not_indexed = r.filter((m) => !m.last_index_update_date);
          // console.log("indexed", indexed);
          v.modules = indexed.concat(not_indexed);
          v.shown_modules = JSON.parse(JSON.stringify(v.modules)).map((m) => {
            m.matches_filter = true;
            return m;
          });
        })
        .catch((err) => {
          error_message(err);
        })
        .finally(() => {
          v.$root.loader(false);
        });
    },
    go_to_module(current_module) {
      let v = this;
      if (current_module.settings.home_url)
        v.$router.push({ path: current_module.settings.home_url });
      else error_message(v.$t("no route defined"));
    },
    go_to_settings() {
      let v = this;
      v.$router.push({ name: "settings" });
    },
    particlesLoaded(/* container */) {
      // console.log("particlesLoaded", container);
    },
  },
  mounted() {
    let v = this;
    v.get_home_modules();

    window.go_to = (module_name) => {
      let module = v.modules.find((m) => m.code_name == module_name);
      if (module) v.go_to_module(module);
    };

    window.focus_search = () => {
      v.$refs.search_input.focus();
    };

    // var Jarvis = new Artyom();
    // Jarvis.initialize({
    //   lang: "es-ES", // GreatBritain english
    //   continuous: true, // Listen forever
    //   soundex: true, // Use the soundex algorithm to increase accuracy
    //   debug: true, // Show messages in the console
    //   executionKeyword: "hazlo ahora",
    //   listen: true, // Start to listen commands !

    //   // If providen, you can only trigger a command if you say its name
    //   // e.g to trigger Good Morning, you need to say "Jarvis Good Morning"
    //   name: "K",
    // })
    //   .then(() => {
    //     console.log("Artyom has been succesfully initialized");
    //   })
    //   .catch((err) => {
    //     console.error("Artyom couldn't be initialized: ", err);
    //   });

    // Jarvis.say("Hola mundo!");

    // Jarvis.on(["Buenos días", "Buenas tardes", "Tu madre"]).then((i) => {
    //   switch (i) {
    //     case 0:
    //       Jarvis.say("Buenos dias, como estás?");
    //       break;
    //     case 1:
    //       Jarvis.say("Buenas tardes, como estás?");
    //       break;
    //     case 2:
    //       Jarvis.say("Metete el dedo");
    //       break;
    //   }
    // });

    // // Jarvis.on(["Repeat after me *"], true).then((i, wildcard) => {
    // //   console.log("xrraxxxxxxxxxxx", i, wildcard);
    // //   Jarvis.say("You've said : " + wildcard);
    // // });

    // // Jarvis.addCommands([
    // //   {
    // //     indexes: ["Hello", "Hi", "is someone there"],
    // //     action: (i) => {
    // //       console.log("xxxxxxxxxxxx", i);
    // //       Jarvis.say("Hello, it's me");
    // //     },
    // //   },
    // //   {
    // //     indexes: ["Repeat after me *"],
    // //     smart: true,
    // //     action: (i, wildcard) => {
    // //       console.log("xxxxxxxxxxssdsdxxx", i, wildcard);
    // //       Jarvis.say("You've said : " + wildcard);
    // //     },
    // //   },
    // //   // The smart commands support regular expressions
    // //   {
    // //     indexes: [/Good Morning/i],
    // //     smart: true,
    // //     action: (i, wildcard) => {
    // //       console.log("xxxxxxxxxxxxyy", i);
    // //       Jarvis.say("You've said : " + wildcard);
    // //     },
    // //   },
    // //   {
    // //     indexes: ["shut down yourself"],
    // //     action: (i, wildcard) => {
    // //       console.log("xxxxxxxxxxxx", i, wildcard);
    // //       Jarvis.fatality().then(() => {
    // //         console.log("Artyom succesfully stopped");
    // //       });
    // //     },
    // //   },
    // // ]);

    // // // Start the commands !

    // // /**
    // //  * To speech text
    // //  */
    // // Jarvis.say(
    // //   "Hello, this is a demo text. The next text will be spoken in Spanish",
    // //   {
    // //     onStart: () => {
    // //       console.log("Reading ...");
    // //     },
    // //     onEnd: () => {
    // //       console.log("No more text to talk");

    // //       // Force the language of a single speechSynthesis
    // //       Jarvis.say("Hola, esto está en Español", {
    // //         lang: "es-ES",
    // //       });
    // //     },
    // //   }
    // // );
  },
  watch: {
    search: function (val) {
      let v = this;
      if (val) {
        v.shown_modules = v.modules.map((m) => {
          m.matches_filter = v
            .$t(m.settings.home_title)
            .toLowerCase()
            .includes(val.toLowerCase());
          return m;
          // return v
          //   .$t(m.settings.home_title)
          //   .toLowerCase()
          //   .includes(val.toLowerCase());
        });
      } else {
        v.shown_modules = v.modules.map((m) => {
          m.matches_filter = true;
          return m;
        });
      }
    },
  },
};
</script>

<style scoped>
/* .grid .cell .card .card-image:hover {
  /* background-color: darkslategrey !important;
  transition: ease-in-out 0.1s;
  transform: matrix(0.97, 0, 0, 0.97, 0, 0);
} */
.grid .cell .card:hover {
  /* background-color: rgba(70, 70, 70, 0.651) !important; */
  border-radius: 0.5em;
  box-shadow: 0px 0px 5px 1px rgba(0, 209, 178, 0.9);
  /* background-color: rgb(29, 29, 29) !important; */
  /* background-color: rgba(0, 174, 255, 0.418) !important; */
  /* background-color: rgba(0, 209, 178, 0.568) !important; */
  /* transition: ease-in-out 0.3s; */
  transition: linear 0.1s;
  transform: scale(1.05, 1.05);
}
.grid .cell .card:active {
  /* background-color: rgba(70, 70, 70, 0.651) !important; */
  border-radius: 20px;
  box-shadow: 0px 0px 5px 1px rgba(0, 209, 178, 0.9);
  /* background-color: rgb(29, 29, 29) !important; */
  /* background-color: rgba(0, 174, 255, 0.418) !important; */
  /* background-color: rgba(0, 209, 178, 0.568) !important; */
  /* transition: ease-in-out 0.3s; */
  transition: ease-out 0.3s;
  transform: scale(1.5, 1.5);
  opacity: 0;
  /* animation: gelatine 0.5s infinite; */
}

.grid .cell .card {
  background-color: rgba(20, 22, 26, 0.4);
}

/* @keyframes gelatine {
  from,
  to {
    transform: scale(1, 1);
  }
  25% {
    transform: scale(0.9, 1.1);
  }
  50% {
    transform: scale(1.1, 0.9);
  }
  75% {
    transform: scale(0.95, 1.05);
  }
} */
</style>
